/**
 * ContactPreferences - העדפות איש קשר
 * כוללת העדפות לגבי פיזור הוני, פיזור קרן השתלמות ועוד
 */

export enum ContactPreferenceType {
  CAPITAL_DISTRIBUTION = "CAPITAL_DISTRIBUTION",           // פיזור הוני
  EDUCATION_FUND_DISTRIBUTION = "EDUCATION_FUND_DISTRIBUTION",  // פיזור קרן השתלמות
  PENSION_DISTRIBUTION = "PENSION_DISTRIBUTION",           // פיזור פנסיה

  // שאלות ללקוח
  HAS_SPECIFIC_PROFESSION = "HAS_SPECIFIC_PROFESSION",  // האם יש מקצוע ספציפי שכדאי לבטח
  PROFESSION_TO_INSURE = "PROFESSION_TO_INSURE",  // המקצוע לביטוח
  GROSS_SALARY = "GROSS_SALARY",  // שכר ברוטו (deprecated - use specific ones below)
  DISABILITY_PERCENTAGE = "DISABILITY_PERCENTAGE",  // ביטוח רצוי לאובדן כושר עבודה באחוזים
  HAS_PROGRESSIVE_DISEASE = "HAS_PROGRESSIVE_DISEASE",  // האם יש מחלה עם תהליך מתפתח
  SIGN_LONGEVITY_AT_BANK = "SIGN_LONGEVITY_AT_BANK",  // לחתום על אריכות ימים בבנק
  CHILDREN_HEALTH_INSURANCE = "CHILDREN_HEALTH_INSURANCE",  // האם יש לילדים ביטוח בריאות

  // שכר ברוטו לפי סוג תעסוקה
  GROSS_SALARY_EMPLOYEE_1 = "GROSS_SALARY_EMPLOYEE_1",  // שכר ברוטו שכיר - עבודה 1
  GROSS_SALARY_EMPLOYEE_2 = "GROSS_SALARY_EMPLOYEE_2",  // שכר ברוטו שכיר - עבודה 2
  GROSS_SALARY_EMPLOYEE_3 = "GROSS_SALARY_EMPLOYEE_3",  // שכר ברוטו שכיר - עבודה 3
  GROSS_SALARY_SELF_EMPLOYED = "GROSS_SALARY_SELF_EMPLOYED",  // שכר ברוטו שנתי - עצמאי
}

/**
 * מבנה הנתונים עבור העדפות פיזור (הוני/פנסיה)
 * נשמר בשדה data של ContactPreferences
 */
export interface PreferenceDistributionData {
  stockExposure: number[];      // מערך של אינדקסים של בלוקים שנבחרו לחשיפה למניות (0-9)
  currencyExposure: number[];   // מערך של אינדקסים של בלוקים שנבחרו לחשיפה למט"ח (0-9)
  foreignExposure: number[];    // מערך של אינדקסים של בלוקים שנבחרו לחשיפה לחו"ל (0-9)
}

export class ContactPreferences {
  id: number = 0;  // מחייב ID עבור ה-hooks factory
  company_id?: number;
  contact_id?: number | null = null;  // אופציונלי - עבור העדפות של contact ספציפי
  family_id?: number | null = null;   // אופציונלי - עבור העדפות משפחתיות
  preference_type: ContactPreferenceType = ContactPreferenceType.CAPITAL_DISTRIBUTION;
  is_family: boolean = false;
  reported_period?: string | null = null;  // ISO date string
  notes?: string | null = null;
  data?: Record<string, any> | null = null;  // JSON data
  created_at?: string;
  updated_at?: string;

  constructor(init?: Partial<ContactPreferences>) {
    Object.assign(this, init);
  }

  /**
   * יצירת אובייקט ריק עם ברירות מחדל עבור contact
   */
  static defaultEmpty(contactId: number, preferenceType: ContactPreferenceType): ContactPreferences {
    return new ContactPreferences({
      contact_id: contactId,
      family_id: null,
      preference_type: preferenceType,
      is_family: false,
      reported_period: null,
      notes: null,
      data: null
    });
  }

  /**
   * יצירת אובייקט ריק עם ברירות מחדל עבור משפחה
   */
  static defaultEmptyFamily(familyId: number, preferenceType: ContactPreferenceType): ContactPreferences {
    return new ContactPreferences({
      contact_id: null,
      family_id: familyId,
      preference_type: preferenceType,
      is_family: true,
      reported_period: null,
      notes: null,
      data: null
    });
  }

  /**
   * בדיקה האם ההעדפה היא משפחתית
   */
  isFamilyPreference(): boolean {
    return this.is_family === true;
  }

  /**
   * קבלת תאריך התקופה המדווחת כ-Date object
   */
  getReportedPeriodAsDate(): Date | null {
    if (!this.reported_period) return null;
    return new Date(this.reported_period);
  }
}
